(function($) {
	var ANIMATION_DELAY = 400;

	$.fn.showLoader = function() {
		this.showLoaderImmediately();

		// Show animation animation
		var $loader = this.find('div.loader');
		$loader
			.hide()
			.fadeIn(ANIMATION_DELAY);

		return this;
	};

	$.fn.showLoaderImmediately = function() {
		var $this = $(this);
		var $loader = $this.find('div.loader');
		if ($loader.length > 0) {
			return this;
		}

		$this
			.css({position: 'relative'})
			.addClass('loading')
			.attr('aria-busy', true);

		$loader = $('<div class="loader"></div>');
		$loader
			.appendTo($this);

		return this;
	};

	$.fn.hideLoader = function() {
		var $this = $(this);
		var $loader = $this.find('div.loader');
		if ($loader.length === 0) {
			return this;
		}

		$this
			.removeClass('loading')
			.attr('aria-busy', false);

		$loader.fadeOut(ANIMATION_DELAY, function() {
			$loader.remove();
		});

		return this;
	};
})(jQuery);
